<div id="layout-wrapper">
	<app-header (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-header>
	<app-topbar></app-topbar>
	<div class="main-content">
		<div class="page-content">
			<div class="container-fluid">
				<router-outlet></router-outlet>
			</div>
		</div>
		<app-footer></app-footer>
	</div>
</div>
